import { Dropdown, type DropdownChangeEvent } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { type TeamSize } from "@relay/editUserForm_EditMutation.graphql";
import { teamSizeOptions } from "./team-size-dropdown.consts";
import { type RenderConfig } from "../ValidatedField";

export function TeamSizeDropdownComponent({
	fieldName,
	fieldValue,
	updateField,
	disabled,
	onChange,
	isValid,
	placeholder,
	required,
}: RenderConfig<TeamSize>) {
	const checkIfDropdownFieldChanged = (e: any) => {
		if (e.value !== fieldValue) {
			if (onChange) {
				onChange();
			}
		}
	};

	return (
		<Dropdown
			options={teamSizeOptions}
			name={fieldName}
			disabled={disabled}
			required={required}
			placeholder={placeholder}
			onChange={(dropdownChangeEvent: DropdownChangeEvent) => {
				updateField(dropdownChangeEvent.value);
				checkIfDropdownFieldChanged(dropdownChangeEvent.value);
			}}
			value={fieldValue}
			className={classNames({ "p-invalid": !isValid })}
		/>
	);
}
